package theme

import kotlinx.coroutines.flow.MutableStateFlow

/**
 * Live theming preferences observed by the theme. When [dynamicColorEnabled] is on (and the platform
 * supports it — only Android 12+), the app uses Material You dynamic color instead of the brand scheme.
 * Loaded from PlayerPreferences at startup and flipped by the start-screen toggle.
 */
object ThemePrefs {
    val dynamicColorEnabled = MutableStateFlow(false)
}

/** Whether Material You dynamic color is available on this platform (Android 12+ only). */
expect fun dynamicColorSupported(): Boolean
